import { render, staticRenderFns } from "./StageAnyOptions.vue?vue&type=template&id=2dc9e04e&"
import script from "./StageAnyOptions.vue?vue&type=script&lang=js&"
export * from "./StageAnyOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports